import type { IntellitagOrderItem } from 'types'
import api from 'lib/api'

export type OrderRedemptionInput = {
  codes?: string[]
  shippingAddress?: {
    firstName?: string
    lastName?: string
    email?: string
    address: string
    country: string
    address2: string
    city: string
    state: string
    zip: string
  }
  user?: {
    firstName: string
    lastName: string
    email: string
  }
  order?: {
    intellitagOrderItems: IntellitagOrderItem[]
  }
}

export function create(data: OrderRedemptionInput) {
  return api
    .post<{ data: unknown }>('/api/v2/order-redemptions', { data })
    .then(({ data }) => data.data)
}
